import React from "react";
import "../styles/Quiz.css";

interface MCQQuestionProps {
  questionNumber: number;
  totalQuestions: number;
  question: string;
  options: string[];
  selectedAnswer: string;
  onSelect: (answer: string) => void;
}

const MCQQuestion: React.FC<MCQQuestionProps> = ({
  questionNumber,
  totalQuestions,
  question,
  options,
  selectedAnswer,
  onSelect,
}) => {
  return (
    <div className="question-card">
      <div className="question-count">
        Question {questionNumber} of {totalQuestions}
      </div>

      <h2>{question}</h2>

      <div className="options-container">
        {options.map((option) => (
          <label
            key={option}
            className={`option ${
              selectedAnswer === option ? "selected-option" : ""
            }`}
          >
            <input
              type="radio"
              checked={selectedAnswer === option}
              onChange={() => onSelect(option)}
            />

            <span>{option}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default MCQQuestion;
